import { useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import i18n from "i18next";

import { showToast } from "../utils/helpers";

const useExportAdapter = (txtData, exportData) => {
  const { t } = useTranslation();
  const toastShownRef = useRef(false);

  const currentLocale = i18n.language;
  const hrefLang = currentLocale === "en" ? "" : `/${currentLocale}`;

  const exportToExcel = useCallback(() => {
    if (!exportData || txtData.length === 0) {
      return showToast(
        t("freeProxyServer.export.emptyMessage"),
        "export-excel",
        toastShownRef,
      );
    }

    const link = document.createElement("a");

    link.setAttribute(
      "href",
      `data:text/json;charset=utf-8,${encodeURIComponent(
        txtData.map(item => item).join("\n"),
      )}`,
    );

    link.setAttribute("download", "Data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, [txtData]);

  const exportToTxt = useCallback(() => {
    if (!exportData || txtData.length === 0) {
      return showToast(
        t("freeProxyServer.export.emptyMessage"),
        "export-txt",
        toastShownRef,
      );
    }

    const blob = new Blob([txtData?.join("\n")], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.download = "Data.txt";
    link.href = url;
    link.click();
  }, [txtData]);

  const exportToUrl = useCallback(() => {
    if (!exportData || txtData.length === 0) {
      return showToast(
        t("freeProxyServer.export.emptyMessage"),
        "export-url",
        toastShownRef,
      );
    }

    localStorage.setItem("exportData", JSON.stringify(exportData));

    const newWin = window.open(`${hrefLang}/export/`, "_blank");

    if (newWin === null) {
      setTimeout(() => {
        window.open(`${hrefLang}/export/`, "_blank");
      });
    }
  }, [exportData, hrefLang]);

  return { exportToExcel, exportToTxt, exportToUrl };
};

export default useExportAdapter;
